import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const Legal = loadable(() => import('./Legal'));

Legal.getInitialState = getInitialState;

export default Legal;
